/**
 *
 * Recipe
 *
 */
import { RouteConstants } from 'app/routes';
import { FC } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import CreateOrUpdateRecipe from './pages/CreateOrUpdateRecipe/CreateOrUpdateRecipe';
import RecipeListPage from './pages/RecipeListPage/RecipeListPage';
import RecipePage from './pages/RecipePage/RecipePage';

interface IProps extends RouteComponentProps {}

const Recipe: FC<IProps> = props => {
  return (
    <Switch>
      <Route
        exact
        path={RouteConstants.recipe.index}
        component={RecipeListPage}
      />

      <Route
        path={RouteConstants.recipe.create}
        component={CreateOrUpdateRecipe}
      />
      <Route
        path={RouteConstants.recipe.edit}
        component={CreateOrUpdateRecipe}
      />

      <Route path={RouteConstants.recipe.details} component={RecipePage} />

      {/* <Redirect
         exact
         from={RouteConstants.garage.index}
         to={RouteConstants.garage.transportList}
       /> */}
    </Switch>
  );
};

export default Recipe;
